import { render, staticRenderFns } from "./ProductsUploadsDetail.vue?vue&type=template&id=3ed29fd6&scoped=true&"
import script from "./ProductsUploadsDetail.vue?vue&type=script&lang=js&"
export * from "./ProductsUploadsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed29fd6",
  null
  
)

export default component.exports